import { GameState } from "@shared/types";
import { css, htmlArray } from "../helpers/webComponents";
import { GameRouteService } from "../services/GameRouteService";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";
import { PlayerService } from "../services/PlayerService";

const styles: string = css`
    :host {
        font-family: "Onesize";
    }

    .title {
        text-align: center;
        margin-top: 10px;
        overflow: auto;
    }

    .header {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin-top: 10px;
    }

    .header img {
        width: auto;
        max-width: 100%;
        height: auto;
        max-height: 100%;
        image-rendering: pixelated;
    }

    .header img:nth-child(n + 2) {
        position: absolute;
    }

    .content {
        height: 100%;
        overflow: hidden;
        margin-top: 10px;
        padding: 0 10px;
    }

    .content .inventory li {
        list-style-type: none;
        background-color:rgb(199, 199, 199);
        color: #000000;
        text-transform: capitalize;
        border: 1px solid #000000;
        padding: 5px;
        margin: 0 0 10px 0;
        display: inline-block;
        
       
            clip-path: polygon(
              0px calc(100% - 7px),
              7px calc(100% - 7px),
              7px 100%,
              calc(100% - 7px) 100%,
              calc(100% - 7px) calc(100% - 7px),
              100% calc(100% - 7px),
              100% 7px,
              calc(100% - 7px) 7px,
              calc(100% - 7px) 0px,
              7px 0px,
              7px 7px,
              0px 7px
            );
       

    }

    ::-webkit-scrollbar {
        width: 0.3em;
      }
      
      ::-webkit-scrollbar-thumb {
        background: #ffffff;
      }

    .inventory {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .content .inventory ul {
        padding: 0;
        gap: 10px;
        height: 100%;
        margin: 0;
        overflow-y: scroll;
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    .content .inventory ul:last-child {
        padding-bottom: 10px;
    }

    .content h2 {
        margin: 0 0 10px 0;
    }

    .content p {
        margin: 0 0 10px 0;
    }

    .content p:last-of-type {
        margin: 0;
    }

    .footer {
        border-radius: 10px 10px 0 0;
        background-color: #52478b;
        border: 1px solid #332c57;
        margin-top: 10px;
        display: flex;
        height: 105px;
    }

    .footer .buttons {
        display: flex;
        flex-direction: column;
        overflow: auto;
        padding: 10px 10px 0 10px;
        height: 100%;
    }

    .footer .button {
        background-color: #7f6ed7;
        border: 1px solid #332c57;
        padding: 5px 10px;
        margin: 0 0 10px 10px;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
    }

    .footer .button.active,
    .footer .button:hover {
        background-color: #332c57;
    }

    .content .inventory li {
        list-style-type: none;
        margin: 0;
        justify-content: center;
        align-items: center;
        display: flex;
        height: 30px;
        border: none;
    }
`;
export class InventoryComponent extends HTMLElement {
    private readonly _gameRouteService: GameRouteService = new GameRouteService();
    private readonly _gameEventService: GameEventService = new GameEventService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        void this.refreshGameState();
    }

    private async refreshGameState(): Promise<void> {
        const state: GameState = await this._gameRouteService.getGameState();

        this.updateGameState(state);
    }

    private updateGameState(state: GameState): void {
        // Handle switching pages, if requested.
        if (state.type === "switch-page") {
            this._gameEventService.switchPage(state.page as Page);

            return;
        }

        // Refresh the web component
        void this.render();
    }

    private async render(): Promise<void> {
        console.log("Rendering InventoryComponent");
        if (!this.shadowRoot) {
            console.log("No shadow root");
            return;
        }

        const elements: HTMLElement[] = htmlArray`
            <style>
                ${styles}
            </style>

           
            ${await this.renderContent()}
           
        `;
        console.log(elements);
        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);
    }

    private async renderContent(): Promise<string> {
        const inventory: Response = await fetch(
            `${VITE_API_URL}game/inventory`, { method: "GET", headers: { "x-playersessionid": new PlayerService().getPlayerSessionId() } }
        );
        const inventoryData: string[] = await inventory.json() as string[];
        console.log(inventoryData);
        console.log(inventoryData.map((item: string) => `<li>${item}</li>`).join(""));
        return `
            <div class="content">
                <div class="inventory">
                    
                    <ul>
                    ${inventoryData.map((item: string) => {
            console.log("Rendering item:", item);
            return `<li>${item}</li>`;
        }).join("")}
                    </ul>
                </div>
            </div>
        `;
    }
}
